import { ActionTree } from 'vuex';
import { DiscoveryWallState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { GetDiscoveryWallRecommendationsAction } from './actions/get-discovery-wall-recommendations.action';

export const DISCOVERY_WALL_ACTIONS: ActionTree<DiscoveryWallState, RootStoreState> = {
  ...new GetDiscoveryWallRecommendationsAction().actions
};
